<template>
  <div>
    <div class="page-header">
      <div
        class="page-header-content container-fluid header-elements-md-inline"
      >
        <div class="d-flex">
          <div class="page-title">
            <h4 class="font-weight-semibold">
              Periodo {{ period.PS_PERIODO_NOME }}
            </h4>
            <div class="text-muted">
              Referente à {{ period.PS_PERIODO_REFERENCIA }}!
            </div>
          </div>
          <a href="#" class="header-elements-toggle text-body d-md-none"
            ><i class="icon-more"></i
          ></a>
        </div>
        <loading-data v-if="isLoading"></loading-data>
        <div v-else class="header-elements d-none py-0 mb-3 mb-md-0">
          <ul class="nav nav-pills justify-content-end align-items-center">
            <li class="nav-item mr-2">
              <select
                name="unit"
                id="unit"
                class="form-control form-control-lg"
                v-model="unityId"
              >
                <option value="">Selecione uma unidade</option>
                <option
                  v-for="unit in units"
                  :key="unit.PS_UNIDADE_ID"
                  :value="unit.PS_UNIDADE_ID"
                >
                  {{ unit.PS_UNIDADE_NOME }}
                </option>
              </select>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="content">
      <div v-if="unityId != '' && !isLoading">
        <div class="d-flex">
          <div class="header-title">
            <h3 class="font-weight-light">Enviar WhatsApp</h3>
          </div>
        </div>
        <datatable-select-to-message
          :unityId="unityId"
          :periodId="periodId"
          :customers="registeredCustomers"
          @sendNPS="sendNPS"
        ></datatable-select-to-message>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import DatatableSelectToMessage from '@/components/period/DatatableSelectToMessage.vue'

export default {
  name: 'WhatsApp',
  components: {
    LoadingData,
    DatatableSelectToMessage,
  },
  data() {
    return {
      periodId: this.$route.params.periodId,
      unityId: '',
      isLoading: true,
      selectAgain: true,
      period: {
        PS_PERIODO_NOME: '',
        PS_PERIODO_REFERENCIA: '',
      },
      units: null,
      registeredCustomers: null,
    }
  },
  watch: {
    unityId: {
      handler(newVal, oldVal) {
        if (newVal !== '') {
          this.getRegisteredCustomers()
        }
      },
    },
  },
  methods: {
    async loadPeriod() {
      try {
        this.period = await this.$store.dispatch('getPeriod', this.periodId)
      } catch (error) {
        if (error && error.message) {
          this.$root.$children[0].$refs.notification.warning(error.message)
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
    async loadUnits() {
      try {
        this.units = await this.$store.dispatch('getUnits')
        this.isLoading = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$children[0].$refs.notification.warning(error.message)
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
    async getRegisteredCustomers() {
      try {
        this.isLoading = true
        const response = await this.$store.dispatch('getRegisteredCustomers', {
          unityId: this.unityId,
          periodId: this.periodId,
        })
        if (response) {
          this.customerTypes = response.customerTypes
          this.registeredCustomers = response.customers
          this.byStatus = response.byStatus
        } else {
          this.registeredCustomers = []
          this.customerTypes = []
          this.$root.$children[0].$refs.notification.danger(
            'Período não encontrado.',
          )
        }

        this.isLoading = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$children[0].$refs.notification.warning(error.message)
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
    async sendNPS(selecteds) {
      try {
        const operation = await this.$store.dispatch('sendWhatsApp', {
          unityId: this.unityId,
          periodId: this.periodId,
          customers: selecteds,
        })
        if (operation.status) {
          this.$root.$children[0].$refs.notification.success(operation.message)
        }
      } catch (error) {
        if (error && error.message) {
          this.$root.$children[0].$refs.notification.warning(error.message)
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },
  mounted() {
    this.loadPeriod()
    this.loadUnits()
  },
}
</script>
